<script setup lang="ts">

import { ModalDefault } from '@shared/ui/modals'
import { AppTextarea, InputPrimary, NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineTutorSelect from '../DisciplineTutorSelect.vue'
import { useModalDisciplineTaskCreate } from '../../model/modal-discipline-task-create.hook'

defineOptions({
  name: 'ModalDisciplineTaskCreate',
})

const {
  refIsOpen,
  refIsSaving,
  refStatusOptions,
  refStatus,
  refTutorId,
  refBookingId,
  refBookingIdMode,
  setBookingId,
  refDescription,
  setStatus,
  setDescription,
  closeModal,
  createTask,
} = useModalDisciplineTaskCreate()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsSaving"
    title="Create manual task"
    @click:overlay="closeModal"
  >
    <div class="modal-discipline-task-create">
      <NativeSelect
        name="task_status"
        label="Status:"
        :options="refStatusOptions"
        :value="refStatus"
        :disabled="refIsSaving"
        @change="setStatus"
      />
      <DisciplineTutorSelect
        v-if="refIsOpen"
        v-model="refTutorId"
        :disabled="refIsSaving"
      />
      <InputPrimary
        type="number"
        name="booking_id"
        label="Booking ID:"
        placeholder="12345"
        required
        :mode="refBookingIdMode"
        :disabled="refIsSaving"
        :value="refBookingId"
        @update:value="setBookingId"
      />
      <AppTextarea
        name="task_description"
        label="Description:"
        placeholder="Type here"
        :value="refDescription"
        :disabled="refIsSaving"
        @input="setDescription"
      />
    </div>
    <template #controls>
      <div class="modal-discipline-task-create__controls">
        <BtnPrimary
          text="Save"
          color="emerald"
          :disabled="refIsSaving"
          @click="createTask"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsSaving"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineTaskForm.scss" />
